export enum Config {
  language = 'language',
}
